// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Rhvy","footer":"ChangeClinic_footer__2iiU0"};